// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#TVFuturesChartContainer,
#TVFuturesChartContainerMobile {
  height: 100%;
  width: 100%;
}
#TVFuturesChartContainer > *,
#TVFuturesChartContainerMobile > * {
  width: 100%;
}

.custom-interval-button {
  margin-left: 8px;
  border: 1px solid #2f2f35;
  border-radius: 8px;
  padding: 6px 10px;
  background: #1b1b1f;
  color: #eaeaea;
  cursor: pointer;
}
.custom-interval-button:hover {
  background: #2a2a30;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/Libraries/FuturesChartContainer/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["#TVFuturesChartContainer,\n#TVFuturesChartContainerMobile {\n  height: 100%;\n  width: 100%;\n}\n#TVFuturesChartContainer > *,\n#TVFuturesChartContainerMobile > * {\n  width: 100%;\n}\n\n.custom-interval-button {\n  margin-left: 8px;\n  border: 1px solid #2f2f35;\n  border-radius: 8px;\n  padding: 6px 10px;\n  background: #1b1b1f;\n  color: #eaeaea;\n  cursor: pointer;\n}\n.custom-interval-button:hover {\n  background: #2a2a30;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
